import './layout.pcss';
import angular from 'angular';
import 'angular-i18n/angular-locale_hu-hu';
import '../../modules/M06-news-list/M06-news-list';

const MODULE_NAME = 'ANYIT-app';

export default angular.module(MODULE_NAME, window.dependencies);



// WEBPACK FOOTER //
// ../source/layouts/ANYIT/layout.js